module.exports = __webpack_public_path__ + "img/desc1.7487ff18.png";